export function createGtmMutationObserver(targetNode: HTMLElement, seconds: number): Promise<any> {
	return new Promise<any>((resolve, reject) => {
		const observer = new MutationObserver((mutations, obs) => {
			obs.disconnect();
			clearTimeout(timeout);
			resolve(mutations);
		});

		observer.observe(targetNode, { childList: true, subtree: true });

		const timeout = setTimeout(() => {
			observer.disconnect();
			reject("Nothing happened! (Emarsys recommendations do not work)");
		}, seconds * 1000);
	});
}
